import SectionHeading from "./SectionHeading";
import { qualityTiers } from "@/mocks/movieData";

export default function QualitySection() {
  return (
    <section id="quality" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Quality"
          title="画质与版本说明：怎么选更合适"
          desc="清晰度越高，画面细节与暗部层次越完整，但对带宽与设备的要求也更高。按你的观看场景选择即可，不必一味追求最高档。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {qualityTiers.map((tier) => (
            <article
              key={tier.name}
              className={`rounded-xl border p-5 transition-colors ${
                tier.badge === "推荐"
                  ? "bg-primary-500 border-primary-500 text-background-50"
                  : "bg-background-50 border-background-200"
              }`}
            >
              <div className="flex items-center justify-between">
                <h3
                  className={`text-base font-semibold ${
                    tier.badge === "推荐" ? "text-background-50" : "text-foreground-950"
                  }`}
                >
                  {tier.name}
                </h3>
                <span
                  className={`px-2 py-0.5 rounded-full text-xs font-label ${
                    tier.badge === "推荐"
                      ? "bg-background-50/20 text-background-50"
                      : "bg-secondary-100 text-secondary-900"
                  }`}
                >
                  {tier.badge}
                </span>
              </div>
              <div
                className={`mt-3 text-2xl font-bold font-heading ${
                  tier.badge === "推荐" ? "text-background-50" : "text-primary-600"
                }`}
              >
                {tier.resolution}
              </div>
              <div className="mt-3 flex items-center gap-1">
                {[1, 2, 3, 4].map((n) => (
                  <span
                    key={n}
                    className={`h-1.5 flex-1 rounded-full ${
                      n <= tier.level
                        ? tier.badge === "推荐"
                          ? "bg-accent-400"
                          : "bg-primary-400"
                        : tier.badge === "推荐"
                          ? "bg-background-50/25"
                          : "bg-background-300"
                    }`}
                  />
                ))}
              </div>
              <p
                className={`mt-4 text-sm leading-relaxed ${
                  tier.badge === "推荐" ? "text-background-200" : "text-foreground-600"
                }`}
              >
                {tier.desc}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-6 rounded-xl bg-background-50 border border-background-200 p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4">
          <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 text-2xl">
            <i className="ri-hard-drive-2-line" />
          </span>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            <strong className="text-foreground-950 font-semibold">小建议：</strong>
            手机与笔记本日常观看，1080P 通常已经足够清晰；只有在投屏、大屏或长期收藏时才需要更高档位。选择前先确认设备的存储空间与网络带宽是否充足。
          </p>
        </div>
      </div>
    </section>
  );
}